import React from 'react';
import { ShieldIcon, TrendingUpIcon, HistoryIcon } from 'lucide-react';
export const DifferenceSection = () => {
  const differences = [{
    icon: <ShieldIcon className="h-8 w-8" data-id="element-55" />,
    title: 'It cannot be copied.',
    description: "Once sold out, it's gone."
  }, {
    icon: <TrendingUpIcon className="h-8 w-8" data-id="element-56" />,
    title: 'It grows in value.',
    description: 'Unlike mass-market products, this edition becomes rarer every year.'
  }, {
    icon: <HistoryIcon className="h-8 w-8" data-id="element-57" />,
    title: "It's part of history.",
    description: "You're not just buying a book — you're securing a legacy."
  }];
  return <div className="bg-gray-900 text-white py-16" data-id="element-58">
      <div className="container mx-auto px-4" data-id="element-59">
        <div className="mb-12" data-id="element-60">
          <h2 className="text-3xl font-bold text-center mb-8" data-id="element-61">
            Why This Is Different
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-62">
            {differences.map((item, index) => <div key={index} className="text-center p-6" data-id="element-63">
                <div className="flex justify-center mb-4 text-yellow-500" data-id="element-64">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-65">{item.title}</h3>
                <p className="text-gray-300" data-id="element-66">{item.description}</p>
              </div>)}
          </div>
        </div>
        <div className="bg-yellow-600 p-6 rounded-lg" data-id="element-67">
          <h3 className="text-2xl font-bold text-center mb-4" data-id="element-68">
            ⚡ Attention Collectors
          </h3>
          <p className="text-center mb-4" data-id="element-69">
            The first units always disappear fast. This is not mass production.
            This is not a reprint.
          </p>
          <p className="text-center font-semibold" data-id="element-70">
            This is your chance to stand among the true collectors who will own
            the only Legacy #7 Cristiano Ronaldo Edition in existence.
          </p>
        </div>
      </div>
    </div>;
};